import { FC } from 'react'
import { ToastManager } from 'react-common'

import { Outlet } from 'react-router-dom'

import { ScrollToTop } from '@/components/ScrollToTop/ScrollToTop'
import { SkipToMainContentButton } from '@/components/SkipToMainContentButton/SkipToMainContentButton'
import { KnowledgeModelWidget } from '@/features/km/KnowledgeModelWidget'
import { NavigationEventBus } from '@/features/microFrontend/NavigationEventBus/NavigationEventBus'
import { CustomFederationContextProvider } from '@/features/microFrontend/useFederation'
import { useInitMicroFrontends } from '@/features/microFrontend/useInitMicroFrontends'
import { Loading } from './components/Loading/Loading'

const App: FC = () => {
  const { federationRoot, isLoaded, failedFragments } = useInitMicroFrontends()

  const isKnowledgeCenterFailed = failedFragments.includes('knowledge-center')

  return (
    <CustomFederationContextProvider root={federationRoot!} isLoaded={isLoaded} failedFragments={failedFragments}>
      {isLoaded && !isKnowledgeCenterFailed && <KnowledgeModelWidget />}
      <SkipToMainContentButton />
      <ToastManager />
      <ScrollToTop />
      <Outlet />
      <Loading />
      <NavigationEventBus />
    </CustomFederationContextProvider>
  )
}

export { App }
